var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',[_c('a',{staticStyle:{"color":"#d7d7d7"},attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("鲁ICP备2024122749号")]),_vm._v(" 山东宇航学会 版权所有 ")])])
}]

export { render, staticRenderFns }